import React from 'react'
import './wpl-tabs.css'

export default function WplTabs({ tabTitles, selected, setSelected, loading = false }) {
    return (<div className='tab-container'>
        {tabTitles.map(t => {
            return <div key={t}
                onClick={() => !loading && setSelected(t)}
                className={`${selected === t ? 'selected' : ''} ${loading && selected === t ? 'blinking' : ''}`}
            >
                <span>{t}</span>
            </div>
        })}
    </div>)
}
